export const alertMixin = {
   data: function(){
      return {
         showAlertInfo: false,
         showAlertWarning: false,
         showAlertDanger: false,
         showAlertSuccess: false,
         showConfirm: false,
         showConfirmInfo: false,
         showModalInfo: false,
         deleteConfirmed: false,
         answer: '',
         msgBody: ''
      }
   },
   methods: {
      alert: function(type, autoclose, force){
         if (!type) { return false; }
         if(!force) { force = 'false'; }
         switch (force) {
            case 'open':
               type = true;
               break;
            case 'close':
               type = false;
               break;
            default:
               type = !type;
               break;
         }
         if(type === true && autoclose){
            this.timeclose(type, autoclose);
         }
      },
      alertInfo: function(autoclose, force){
         if(!force) { force = 'false'; }
         switch (force) {
            case 'open':
               this.showAlertInfo = true;
               break;
            case 'close':
               this.showAlertInfo = false;
               break;
            default:
               this.showAlertInfo = !this.showAlertInfo;
               break;
         }
         if(this.showAlertInfo === true && autoclose){
            this.autoclose(this.alertInfo);
         }
      },
      alertSuccess: function(){
         this.showAlertSuccess = !this.showAlertSuccess;
         if(this.showAlertSuccess === true){
            this.autoclose(this.alertSuccess);
         }
      },
      alertWarning: function(){
         this.showAlertWarning = !this.showAlertWarning;
      },
      autoclose: function (alertfn, time) {
         if (!time) {
            time = 3000;
         }
         setTimeout(function () {
            alertfn();
         }, time);
      },
      timeclose: function (alert, time) {
         if (!time) {
            time = 3000;
         }
         var that = this;
         setTimeout(function () {
            that.alert(alert, false, 'close');
         }, time);
      },
      lunchModalConfirm: function(){
         this.showConfirm = true;
      },
      closeModalConfirm: function(){
         this.showConfirm = false;
      }
   }
};


// WEBPACK FOOTER //
// ./src/Banet/mixins/alertMixin.js